import React, { useEffect, useState } from "react";
import "./SubCategoryScreen.scss";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import ProductList from "../../components/ProductList";
import Lottie from "react-lottie";
import {
  defaultOptionsEmpty,
  defaultOptionsLoading,
} from "../../assets/lottie-animations/animationOptions";
import { api } from "../../config/baseApi";
import { Helmet } from "react-helmet-async";

function SubCategoryScreen() {
  const { subCategoryId } = useParams();
  const navigate = useNavigate();

  const [products, setProducts] = useState<any[]>([]);
  const [subCategoryName, setSubCategoryName] =
    useState<string>("Sub Category");
  const [loading, setLoading] = useState(false);

  const getProductsBySubCategory = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${api}/products/subcategory/${subCategoryId}`,
      );

      const list = res?.data?.content?.products || [];

      setProducts(list);

      // ✅ get subCategory name from first product
      if (list.length > 0) {
        setSubCategoryName(list[0]?.subCategory?.name || "Sub Category");
      }
    } catch (error) {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!subCategoryId) return;
    getProductsBySubCategory();
  }, [subCategoryId]);

  return (
    <>
      <Helmet>
        <title>
          Accessoires téléphone en Tunisie | Coques, chargeurs | Mhiri Store
        </title>
        <meta
          name="description"
          content="Tous les accessoires pour téléphone en Tunisie : coques, chargeurs rapides, câbles, protections écran."
        />
      </Helmet>

      <NavBar page={"shop"} />
      <h1 style={{ display: "none" }}>Accessoires pour téléphone</h1>

      <div className="subcategory-container">
        {/* ✅ Header */}
        <div className="subcategory-header">
          <button className="btn-back" onClick={() => navigate(-1)}>
            <i className="bx bx-left-arrow-alt" />
            Retour
          </button>

          <div className="subcategory-title">
            <h2>{subCategoryName}</h2>
            <p>{products.length} produit(s)</p>
          </div>
        </div>

        {/* ✅ Content */}
        {loading ? (
          <div className="subcategory-loading">
            <Lottie options={defaultOptionsLoading} height={150} width={150} />
          </div>
        ) : products.length > 0 ? (
          <div className="subcategory-products">
            <ProductList listProducts={products} type={"product"} />
          </div>
        ) : (
          <div className="subcategory-empty">
            <Lottie options={defaultOptionsEmpty} height={220} width={220} />
            <h3>Aucun produit trouver</h3>
            <p>Cette catégorie ne contient aucun produit pour le moment.</p>
          </div>
        )}
      </div>

      <Footerr />
    </>
  );
}

export default SubCategoryScreen;
